import storage from 'store'
import expirePlugin from 'store/plugins/expire'
storage.addPlugin(expirePlugin)
const tableSelectColumns = {
  state: JSON.parse(localStorage.getItem('userTableSelectColumns')) || {},
  mutations: {
    SET_CHECKED_VALUE_LIST: (state, { tableName, checkedValueList }) => {
      state[tableName] = { checkedValueList }
      localStorage.setItem('userTableSelectColumns', JSON.stringify(state))
    },
    CLEAR_CHECKED_VALUE_LIST: (state) => {
      Object.keys(state).forEach((key) => {
        state[key] = { checkedValueList: null }
      })
      localStorage.removeItem('userTableSelectColumns')
    },
  },
  actions: {},
}
export default tableSelectColumns
